/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
 */

import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { DiagnosisApi } from '../api/diagnosis.api';
import { DiagnosisData, Diagnosis } from '../../../interfaces/masters/diagnosis';

@Injectable()
export class DiagnosisService extends DiagnosisData {

  constructor(private api: DiagnosisApi) {
    super();
  }
  list(): Observable<Diagnosis[]> {
    return this.api.list();
  }
  searchList(url: string,data:any): Observable<any> {
      return this.api.searchList(url,data);
  }
  getById(url:string): Observable<Diagnosis>{
      return this.api.getById(url);
  }
  create(url: string, data:Diagnosis): Observable<Diagnosis> {
    return this.api.add(url,data);
  }
  update(url: string, data:Diagnosis): Observable<Diagnosis> {
    return this.api.update(url,data);
  }
  delete(url: string): Observable<boolean> {
    return this.api.delete(url);
  }
}
